module.exports = __webpack_public_path__ + "static/media/safari.d9013cdf.svg";